import { DocumentTypeHandler } from "@/dbot/common/commonDomain";
import {
  applyForm,
  ArticlesOfAssociation,
  ArticlesOfAssociationForm,
} from "./articlesofassociationDomain";
import { DocumentType } from "@/common/documents";
import { noop } from "lodash";

export const articlesOfAssociationHandler: DocumentTypeHandler<
  DocumentType.articlesofassociation,
  ArticlesOfAssociation,
  ArticlesOfAssociationForm
> = {
  type: DocumentType.articlesofassociation,
  initNewForm: (_, context) => new ArticlesOfAssociationForm(context.documentData),
  initForm: noop,
  applyForm: (form) => applyForm(form),
};
